
(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const image=root.querySelector('[data-main-image]');
    const link=root.querySelector('[data-main-link]');
    const form=root.querySelector('.mp-form');
    if(!form) return;
    const returnBuy=root.querySelector('[data-return-buy]');
    if(returnBuy && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries=>{
        returnBuy.hidden=entries[0].isIntersecting;
        root.toggleAttribute('data-purchase-visible',entries[0].isIntersecting);
      },{threshold:0}).observe(form);
    }
    const helpButton=root.querySelector('[data-mbl-chat-open]');
    if(helpButton && window.customElements) {
      customElements.whenDefined('shopify-chat').then(()=>{
        helpButton.disabled=false;
        helpButton.addEventListener('click',()=>{
          document.querySelector('shopify-chat')?.setAttribute('open','');
        });
      });
    }
    function imageUrl(url,width){const result=new URL(url,window.location.origin);result.searchParams.set('width',width);return result.href;}
    function imageSrcset(url,widths){return widths.map(width=>imageUrl(url,width)+' '+width+'w').join(', ');}
    function showImage(url,alt){image.srcset=imageSrcset(url,[360,600,900]);image.src=imageUrl(url,900);image.alt=alt;link.href=url;}
    root.querySelectorAll('[data-gallery]').forEach(button=>button.addEventListener('click',()=>showImage(button.dataset.gallery,button.getAttribute('aria-label'))));
    const variantInputs=Array.from(form.querySelectorAll('input[name="id"]'));
    function selectVariant(input,updateUrl){
      input.checked=true;
      root.querySelector('[data-add-button]').disabled=input.disabled;
      root.querySelector('[data-price-total]').textContent=input.dataset.price;
      const compare=root.querySelector('[data-compare-total]');compare.textContent=input.dataset.compare;compare.hidden=!input.dataset.compare;
      showImage(input.dataset.image,input.dataset.alt);
      const mobilePackImage=root.querySelector('[data-mobile-pack-image]');
      if(mobilePackImage){root.querySelector('[data-mobile-pack-source]').srcset=imageSrcset(input.dataset.image,[96,192]);mobilePackImage.alt=input.dataset.alt;}
      const thumb=root.querySelector('[data-pack-thumbnail]');thumb.dataset.gallery=input.dataset.image;thumb.setAttribute('aria-label',input.dataset.alt);const packThumb=root.querySelector('[data-pack-thumb]');packThumb.srcset=imageSrcset(input.dataset.image,[64,128,192]);packThumb.src=imageUrl(input.dataset.image,128);
      if(updateUrl){const url=new URL(window.location.href);url.searchParams.set('variant',input.value);history.replaceState(history.state,'',url);}
    }
    variantInputs.forEach(input=>input.addEventListener('change',()=>selectVariant(input,true)));
    const requestedVariant=new URL(window.location.href).searchParams.get('variant');
    const linkedVariant=variantInputs.find(input=>input.value===requestedVariant);
    if(linkedVariant) selectVariant(linkedVariant,false);
    form.addEventListener('submit',async event=>{
      event.preventDefault();const button=root.querySelector('[data-add-button]');if(button.disabled) return;
      button.disabled=true;button.setAttribute('aria-busy','true');const error=root.querySelector('[data-form-error]');error.hidden=true;
      try {const response=await fetch(root.dataset.add,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});const result=await response.json();if(!response.ok) throw new Error(result.description||result.message||error.textContent);window.location.assign(root.dataset.cart);}
      catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');}
    });
    root.querySelectorAll('a[href="#mp-label"]').forEach(a=>a.addEventListener('click',()=>root.querySelector('#mp-label').open=true));
  }
  document.querySelectorAll('[data-parasitol-landing]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-parasitol-landing]').forEach(init));
})();
